import Modal from "react-bootstrap/Modal";
import { AvailabilityEditType } from "../components/AvailabilityEditType";
import { useEffect, useState } from "react";

export const AvailabilityEditModal = ({
  visible,
  close,
  pageHeaderMsg,
  forceUpdate,
  availabilityObject,
}) => {
  const [user, setUser] = useState(null);
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (visible) {
      setUser(
        availabilityObject?.user?.surname +
          ", " +
          availabilityObject?.user?.forename,
      );
      setDate(availabilityObject?.date);
    } else {
      setDate(null);
      setUser(null);
    }
  }, [visible]);

  const displayBody = () => {
    if (availabilityObject === null) return null;
    return (
      <AvailabilityEditType
        visible={visible}
        forceUpdate={forceUpdate}
        close={close}
        pageHeaderMsg={pageHeaderMsg}
        availabilityObject={availabilityObject}
      />
    );
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h2>Edit Availability</h2>
      </Modal.Header>
      <Modal.Body>{displayBody()}</Modal.Body>
    </Modal>
  );
};
